import React from 'react';

export default function Logo({ variant = 'dark', className = '' }) {
  const fg = variant === 'light' ? '#FFFFFF' : '#1B3A6B';
  const accent = '#2B7FD4';
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="studioops-logo">
      <svg width="32" height="32" viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <rect x="2" y="2" width="36" height="36" rx="8" fill={fg} />
        <path
          d="M12 26 L12 14 L20 14 C24 14 26 16 26 19 C26 22 24 24 20 24 L17 24 L17 26 Z"
          fill={accent}
        />
        <circle cx="28" cy="14" r="3" fill={accent} />
      </svg>
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-bold tracking-tight" style={{ color: fg }}>
          StudioOps
        </span>
        <span className="text-[10px] font-medium uppercase tracking-[0.14em]" style={{ color: variant === 'light' ? 'rgba(255,255,255,0.7)' : '#64748B' }}>
          Appointment
        </span>
      </div>
    </div>
  );
}
